export default "__VITE_ASSET__4f4a72d9__"